import { render, staticRenderFns } from "./AthleteScheduleView.vue?vue&type=template&id=659e25ac&scoped=true&"
import script from "./AthleteScheduleView.vue?vue&type=script&lang=ts&"
export * from "./AthleteScheduleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e25ac",
  null
  
)

export default component.exports